import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classes from "./UIModal.scss";
import Modal from "react-modal";
import classNames from "classnames";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import { PrivateComponent } from "../PrivacyAware";
import { formatDate } from "Utils";
import {
  getIsCurrentAcademicYearSelected,
  getIsPreviousAcademicYearSelected,
} from "modules/CommonSelectors";
import { selectedAcademicYearSelector } from "Platform/modules/PlatformModule";
import update from "immutability-helper";
import {
  getCumulativeGlobalHeaderHeight,
  enableGlobalHeader,
  disableGlobalHeader,
} from "Login/modules/LoginModule";

class UIModal extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillMount = () => {
    const {
      forceHideGlobalHeader,
      disableGlobalHeader,
      isFullScreen,
    } = this.props;
    if (isFullScreen && forceHideGlobalHeader) {
      disableGlobalHeader();
    }
  };

  componentWillUnmount() {
    const {
      forceHideGlobalHeader,
      enableGlobalHeader,
      isFullScreen,
    } = this.props;
    if (isFullScreen && forceHideGlobalHeader) {
      enableGlobalHeader();
    }
  }

  onRequestClose = e => {
    const { onRequestClose } = this.props;
    if (onRequestClose) {
      onRequestClose(e);
    }
  };

  afterOpenModal = () => {
    // if (this.overlayRef) {
    //   this.overlayRef.addEventListener(
    //     "touchmove",
    //     e => {
    //       console.log(e.target, this.overlayRef);
    //       if (!this.overlayRef.contains(e.target)) {
    //         e.preventDefault();
    //       }
    //     },
    //     false
    //   );
    // }
  };

  setFocusOnContent = () => {
    if (this.contentRef) {
      this.contentRef.focus();
    }
  };

  handleContentRef = ref => (this.contentRef = ref);

  handleOverlayRef = ref => (this.overlayRef = ref);

  render() {
    const {
      isOpen,
      overlayContainer,
      modalContent,
      isFullScreen,
      customStyle,
      academicYearSelected,
      isTeacherPage,
      t,
      isArchived,
      isArchivedCourse,
      shouldCloseOnOverlayClick,
      hideArchiveBanner,
      isAdminPage,
      isCurrentAcademicYearSelected,
      isPreviousAcademicYearSelected,
      isGlobalMenuTray,
      testId,
      childrenContainerCustomStyle,
      childrenAndBannerContainerCustomStyle,
      isGlobalHeaderVisible,
      isUserImpersonated,
      getCumulativeGlobalHeaderHeight,
      tabIndexValue,
      shouldFocusAfterRender = true,
      showFromTopOfTheViewPort = false,
    } = this.props;

    const shiftFullScreenModalToBottom =
      isFullScreen && (isGlobalHeaderVisible || isUserImpersonated);

    let updatedCustomStyle = customStyle;

    if (shiftFullScreenModalToBottom) {
      updatedCustomStyle = update(updatedCustomStyle, {
        overlay: (overlay = {}) => {
          return {
            ...overlay,
            top: showFromTopOfTheViewPort
              ? 0
              : getCumulativeGlobalHeaderHeight(),
            height: "unset",
          };
        },
      });
    }

    const startDate = _.get(academicYearSelected, "startDate", "");
    const endDate = _.get(academicYearSelected, "endDate", "");
    // const childrenStyle = classNames({
    //   [classes.childrenNormal]: isCurrentAcademicYearSelected,
    //   [classes.childrenSmall]: !isCurrentAcademicYearSelected
    // });
    const overlayContainerClass = classNames(
      { [classes.overlayContainer]: true },
      { [classes.noFullscreenOverlaycontainer]: !isFullScreen },
      { [classes.trayOverlaycontainer]: isGlobalMenuTray },
      { [overlayContainer]: !!overlayContainer }
    );

    const modalContentClass = classNames(
      { [classes.modalContent]: true },
      { [classes.fullScreenModalContent]: isFullScreen },
      { [modalContent]: !!modalContent }
    );

    const showArchivedAlert =
      (isArchivedCourse || isArchived) && isFullScreen && !hideArchiveBanner;

    const showPreviousYearAlert =
      !isCurrentAcademicYearSelected &&
      isFullScreen &&
      /**
       * Since previous academic year warning is shown at homepage and in global header, we move
       * UIModal downwards, we don't need to show it in modals when global header is present
       */
      !shiftFullScreenModalToBottom;

    const previousYearAlert = t(
      isPreviousAcademicYearSelected
        ? "common:previous_academic_year_view_alert"
        : "common:future_academic_year_view_alert",
      {
        year: `${formatDate({
          date: startDate,
          format: "YYYY",
        })}-${formatDate({ date: endDate, format: "YY" })}`,
      }
    );

    const showAlertBanner = showArchivedAlert || showPreviousYearAlert;
    const alertBannerContent = showArchivedAlert
      ? isArchivedCourse
        ? t("common:inside_archived_course")
        : t("common:inside_archived_class")
      : showPreviousYearAlert
      ? previousYearAlert
      : null;

    const childrenClasses = classNames(classes.modalChildren, {
      [classes.modalChildrenResize]: showAlertBanner,
    });

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.onRequestClose}
        overlayClassName={overlayContainerClass}
        className={modalContentClass}
        ariaHideApp={false}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        shouldFocusAfterRender={shouldFocusAfterRender}
        contentRef={this.handleContentRef}
        overlayRef={this.handleOverlayRef}
        onAfterOpen={this.afterOpenModal}
        style={updatedCustomStyle}
        testId={testId || (isFullScreen && "fullscreen-ui-modal")}
      >
        {this.props.children && (
          <PrivateComponent isScreen={true}>
            <div
              className={classes.childrenContainer}
              style={childrenAndBannerContainerCustomStyle}
            >
              {showAlertBanner && (
                <div className={classes.alertBanner}>{alertBannerContent}</div>
              )}
              <div
                className={childrenClasses}
                style={childrenContainerCustomStyle}
                tabIndex={tabIndexValue}
              >
                {this.props.children}
              </div>
            </div>
          </PrivateComponent>
        )}
      </Modal>
    );
  }
}

UIModal.defaultProps = {
  isOpen: false,
  onRequestClose: null,
  modalContent: "",
  overlayContainer: "",
  isFullScreen: false,
  customStyle: { content: {}, overlay: {} },
  academicYearSelected: {},
  isTeacherPage: true,
  shouldCloseOnOverlayClick: true,
  hideArchiveBanner: false,
  childrenContainerCustomStyle: {},
  childrenAndBannerContainerCustomStyle: {},
};

UIModal.propTypes = {
  isOpen: PropTypes.bool,
  modalContent: PropTypes.string,
  onRequestClose: PropTypes.func,
  overlayContainer: PropTypes.string,
  customStyle: PropTypes.object,
  academicYearSelected: PropTypes.object,
  isTeacherPage: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  hideArchiveBanner: PropTypes.bool,
  childrenContainerCustomStyle: PropTypes.object,
  childrenAndBannerContainerCustomStyle: PropTypes.object,
};
// for previous academic year warning
const mapStateToProps = state => {
  const academicYearSelected = selectedAcademicYearSelector(state);
  const activeTab = _.get(state, "login.activeTab", "");

  // for previous academic year warning
  const isCurrentAcademicYearSelected = getIsCurrentAcademicYearSelected(state);
  const isPreviousAcademicYearSelected = getIsPreviousAcademicYearSelected(
    state
  );

  const isArchivedCourse = _.get(
    state,
    "learningCourse.selectedLearningCourse.isArchived"
  );

  const isArchivedClass = _.get(
    state,
    "teacher.selected_class.isArchivedClass"
  );
  const isRemovedCourseForLoggedInUser = _.get(
    state,
    "teacher.selected_class.isRemovedCourseForLoggedInUser"
  );
  const isArchived = isArchivedClass || isRemovedCourseForLoggedInUser;

  return {
    academicYearSelected,
    isTeacherPage: activeTab == "teacher",
    isArchived,
    isArchivedCourse,
    isAdminPage: activeTab == "admin",
    isCurrentAcademicYearSelected,
    isPreviousAcademicYearSelected,
    isGlobalHeaderVisible: _.get(state, "login.globalHeader.isVisible", false),
    isUserImpersonated: _.includes(
      state.login.banners,
      "USER_IMPERSONATION_ALERT"
    ),
  };
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(
    mapStateToProps,
    {
      getCumulativeGlobalHeaderHeight,
      enableGlobalHeader,
      disableGlobalHeader,
    },
    null,
    {
      withRef: true,
    }
  )
)(UIModal);
